export const queries = [
    {
        name: 'draftContracts',
        counter: 'drafts',
        query: 'draftContractsp',
        rol: 'DASHBOARD_VIEW_COUNTER_DRAFTS'
    },
    {
        name: 'pendingContracts',
        counter: 'pending',
        query: 'pendingContractsp',
    },
    {
        name: 'signedContracts',
        counter: 'signed',
        query: 'signedContractsp',
    },
   /*
    {
        name: 'potentialRisks',
        counter: 'risks',
        url: '/risks',
        query: 'risksp',
    },*/
    {
        name: 'recentlyApproved',
        counter: 'receivedForApproval',
        query: 'receivedContractsp',
        rol: 'DASHBOARD_VIEW_COUNTER_RECENTLY_APPROVED'
    },
    {
        name: 'videoValidation',
        counter: 'videoValidation',
        query: 'videoValidationRequiredp',
    },
    {
        name: 'daysToExpire',
        counter: 'daysToExpire',
        query: 'daysToExpirep'
    },
    {
        name: 'negotiation',
        counter: 'negotiation',
        query: 'negotiationp',
    },
    {
        name: 'sentContracts',
        counter: 'sentContracts',
        query: 'sentContractsp',
    },
    {
        name: 'expiredContracts',
        counter: 'expiredContracts',
        query: 'expiredContractsp',
    },
    {
        name: 'withComments',
        counter: 'withComments',
        query: 'withCommentsp',
    }
];